/**
 * Shared EUR formatter for admin cost surfaces (#494 A8, reused by #400 A9).
 *
 * German locale: thousands `.`, decimal `,`, always two fraction digits, with
 * the euro sign — e.g. `formatEur(12345.67)` → `"12.345,67 €"`. Null/undefined
 * fall back to zero so a partial API payload can't render `"NaN €"`.
 */
const eurFormatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

export const formatEur = (value: number | null | undefined): string => eurFormatter.format(value ?? 0);
